


import React from "react";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { getIn } from "formik";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Typography from "@mui/material/Typography";
import "react-phone-number-input/style.css";
import { Box, IconButton } from "@mui/material";


export const PhoneInputFormField = ({
    field,
    form,
    label,
    isRequired,
    startIcon,
    endIcon,
    OnButtonClick,
    isOtpSent, // <-- Pass this from parent to control OTP sent state
    ...props
}) => {
    const errorText = getIn(form.touched, field.name) && getIn(form.errors, field.name);
    const phoneValue = field.value ?? "";
    const isPhoneValid = isValidPhoneNumber(phoneValue || ""); // use react-phone-number-input's validation

    // Button state logic
    const isButtonDisabled = !isPhoneValid || isOtpSent;

    return (
        <FormControl fullWidth error={!!errorText}>
            {label && (
                <Box sx={{ mb: 2 }}>
                    <InputLabel sx={{ ml: -1.6, textTransform: "capitalize" }} shrink htmlFor={field.name}>
                        <Typography variant="body1">
                            {label}
                            {isRequired && (
                                <Typography variant="h6" color="error" component="span">
                                    {" *"}
                                </Typography>
                            )}
                        </Typography>
                    </InputLabel>
                </Box>
            )}

            {/* Input container with optional icons */}
            <Box sx={{ position: "relative", display: "flex", alignItems: "center" }}>
                <PhoneInput
                    international
                    defaultCountry="IN"
                    value={phoneValue}
                    countryCallingCodeEditable={false}
                    onChange={(value) => form.setFieldValue(field.name, value ?? "")}
                    onBlur={() => {
                        form.setFieldTouched(field.name, true, true);
                    }}
                    {...props}
                    style={{
                        border: "0.5px solid #DC143C",
                        padding: "14px 10px",
                        paddingLeft: startIcon ? "40px" : "10px",
                        paddingRight: endIcon ? "40px" : "10px",
                        borderRadius: "5px",
                        fontSize: "15px",
                        width: "100%",
                    }}
                />

                {endIcon && (
                    <IconButton
                        sx={{
                            position: "absolute",
                            right: 10,
                            top: 2,
                            bottom: 2,
                            zIndex: 1,
                            borderRadius: 1,
                            bgcolor: "#FAEAEE",
                         

                            // Normal hover
                            "&:hover": {
                                bgcolor: "#FAEAEE", // slightly darker
                            },

                            // Disabled state
                            "&.Mui-disabled": {
                                bgcolor: "#F5F5F5", // lighter shade
                                color: "#C9AAB2",   // lighter icon/text
                                cursor: "not-allowed",
                            },

                            // Prevent hover darkening when disabled
                            "&.Mui-disabled:hover": {
                                bgcolor: "#F5F5F5",
                            },
                        }}
                        disabled={isButtonDisabled}
                        onClick={() => OnButtonClick?.(phoneValue)}
                    >
                        {endIcon}
                    </IconButton>
                )}
            </Box>

            {errorText && (
                <Typography variant="body2" fontSize={"10px"} color="#DC143C" component="span">
                    {errorText}
                </Typography>
            )}
        </FormControl>
    );
};











